"use strict";

exports.__esModule = true;
exports.default = void 0;
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
function frequentFlyerFactory(frequentFlyer, language) {
  var _frequentFlyer$label$, _frequentFlyer$label;
  if (language === void 0) {
    language = _constants.LANGUAGE.EN;
  }
  return {
    label: (_frequentFlyer$label$ = frequentFlyer === null || frequentFlyer === void 0 ? void 0 : (_frequentFlyer$label = frequentFlyer.label) === null || _frequentFlyer$label === void 0 ? void 0 : _frequentFlyer$label[language]) !== null && _frequentFlyer$label$ !== void 0 ? _frequentFlyer$label$ : '',
    operatorCode: frequentFlyer === null || frequentFlyer === void 0 ? void 0 : frequentFlyer.operatorCode,
    country: frequentFlyer === null || frequentFlyer === void 0 ? void 0 : frequentFlyer.country,
    group: frequentFlyer === null || frequentFlyer === void 0 ? void 0 : frequentFlyer.group,
    number: frequentFlyer === null || frequentFlyer === void 0 ? void 0 : frequentFlyer.number
  };
}
var _default = exports.default = frequentFlyerFactory;